import React from "react";

export type TabProps = {
  active?: boolean;
  children: React.JSX.Element | React.JSX.Element[] | React.ReactNode;
  size?: "sm" | "md" | "lg";
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  useButton?: boolean;
};

export function Tab({
  children,
  active = false,
  onClick,
  size = "md",
  useButton = true
}: TabProps) {
  const baseClasses = "Tab tab-base";
  const stateClasses = active ? "tab-active" : "tab-inactive";
  const sizeClasses = `tab-${size ?? "md"}`;

  const className = `${baseClasses} ${stateClasses} ${sizeClasses}`;

  return (
    <>
      {useButton && (
        <button className={className} onClick={onClick} tabIndex={0}>
          <div className="Tab__Item">{children}</div>
        </button>
      )}
      {!useButton && (
        <div className={className}>
          <div className="Tab__Item">{children}</div>
        </div>
      )}
    </>
  );
}
